import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminLanguage } from '../AdminLanguageContext';

export default function NotFound() {
  const { copy } = useAdminLanguage();
  const notFoundCopy = copy.notFound;

  return (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ fontSize: 96, fontWeight: 800, background: 'linear-gradient(135deg, #667eea, #764ba2)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', lineHeight: 1, marginBottom: 12 }}>404</div>
      <h1 style={{ fontSize: 22, marginBottom: 8 }}>{notFoundCopy.title}</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>{notFoundCopy.description}</p>
      <Link to="/" className="btn btn-primary">{notFoundCopy.back}</Link>
    </div>
  );
}
